import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForgotPasswordRoutingModule } from './forgot-password-routing.module';
import { ForgotPasswordComponent } from './forgot-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgZorroIconModule } from '../../../modules/nz-icon-antd.module';
import { NgZorroAntdModule } from '../../../modules/nz-zorro-antd.module';
import { I18nService } from '../../../services/i18n.service';
import { NotificationService } from '../../../services/notification.service';
import { HeaderModule } from '../../../shared/header/header.module';
import { FooterModule } from '../../../shared/footer/footer.module';
import { ValidationErrorsModule } from '../../../shared/validation-errors/validation-errors.module';
import { InputFieldModule } from 'src/app/shared/input-field/input-field.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		ForgotPasswordComponent
	],
	imports: [
		CommonModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		ForgotPasswordRoutingModule,
		ReactiveFormsModule,
		HeaderModule,
		FooterModule,
		ValidationErrorsModule,
		InputFieldModule,
		TranslateModule
	],
	exports: [
		ForgotPasswordComponent
	],
	providers: [
		I18nService,
		NotificationService
	]
})

export class ForgotPasswordModule { }
